<top-progress-bar></top-progress-bar>
<div class="common-layout"
    [ngClass]="{
        'is-folded': isFolded,
        'is-expand' : isExpand
    }"
>
    <app-header></app-header>
    <app-sidenav [menuItems]="sideMenus"></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <h4 class="page-title" *ngIf="breadcrumbs$ | async; let breadcrumbs">{{(breadcrumbs[breadcrumbs.length - 1].label)}}</h4>
                <nz-breadcrumb nzSeparator=">" [nzAutoGenerate]="true">
                    <i class="m-r-5 text-gray" nz-icon nzType="home"></i>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                        <a [routerLink]="breadcrumb.url">
                            {{ breadcrumb.label }}
                        </a>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
            </div>
          <nz-card class="w-100" style="min-height: 700px">
            <router-outlet></router-outlet>
          </nz-card>
        </div>
        <app-footer></app-footer>
    </div>
</div>
